import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContainerSelectorComponent } from './container-selector.component';
import { DescriptionResolver } from '../descriptions/description.resolver';
import { DescriptionService } from '../descriptions/description.service';
import { PipesModule } from '../pipes/pipes.module';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
  imports: [CommonModule, PipesModule, ReactiveFormsModule],
  declarations: [ContainerSelectorComponent],
  exports: [ContainerSelectorComponent],
  providers: [DescriptionResolver, DescriptionService],
})
export class ContainerSelectorModule {}
